<template>
  <div class="container course-create">
    <div class="header">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>订单管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/order/list' }">订单管理</el-breadcrumb-item>
        <el-breadcrumb-item>订单创建</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <el-button
            type="primary"
            @click="openAdminOrderTableDialog"
          >订单创建任务列表</el-button>
        </div>
        <div class="right">
          <el-button
            plain
            @click="handleClose"
          >取消</el-button>
          <el-button
            type="primary"
            :loading="loading"
            @click="handleSubmit"
          >保存</el-button>
        </div>
      </div>
    </div>
    <div class="main">
      <h3 class="title">订单详情</h3>

      <div class="content">
        <el-form
          :model="dataForm"
          :rules="rules"
          ref="dataForm"
          label-width="130px"
          class="dataForm"
        >
          <el-form-item
            label="订单用户："
            prop="users"
          >
            <div class="tag-wrap">
              <el-tag
                class="user-item"
                size="medium"
                :key="item.id"
                v-for="item in users"
                closable
                :disable-transitions="false"
                @close="handleUserRemove(item)"
              >
                {{item.mobile ? `${item.nickname || item.username}/${item.mobile}` : (item.nickname || item.username)}}
              </el-tag>
              <el-tag
                type="success"
                class="user-item"
                size="medium"
                :key="index"
                v-for="(item,index) in userMobiles"
                closable
                :disable-transitions="false"
                @close="handleRemoveUserMobile(item,index)"
              >
                {{item.mobile}}
              </el-tag>
              <el-button
                type="text"
                @click="handleUserChoose"
              >选择用户</el-button>
              <el-button
                type="text"
                @click="openAddUserDialog"
              >添加未注册用户</el-button>

            </div>
          </el-form-item>
          <el-form-item
            label="选择商品："
            prop="ref_id"
          >
            <div class="tag-wrap">
              <el-tag
                class="user-item"
                size="medium"
                :key="item.id"
                v-for="item in products"
                closable
                :disable-transitions="false"
                @close="handleProductsRemove(item)"
                type="success"
              >
                {{item.name}}
              </el-tag>
              <el-button
                type="text"
                @click="handleGoodChoose"
              >选择商品</el-button>
            </div>
          </el-form-item>
          <!--         <el-form-item
            label="商品价格："
            prop="price"
          >
            <el-input
              :value="goods.price"
              placeholder="必填项，不允许为负数"
            ></el-input>
          </el-form-item> -->
        </el-form>
      </div>
    </div>
    <MemberChoose
      :visible="userChooseDialog"
      @close="userChooseDialog = false"
      @submit="saveMember"
    ></MemberChoose>

    <adminOrderTable
      :isVisible="adminOrderTableDialog"
      @close="handleClose"
    >
    </adminOrderTable>
    <GoodsTabsChoose
      :visible="goodsChooseDialog"
      type="multiple"
      @close="goodsChooseDialog = false"
      @submit="saveGoods"
      :goods="products"
    />
    <AddUserMobile
      :isVisible="adduserDialog"
      @close="adduserDialog=false"
      @submit="adduserDialogSubmit"
    />
  </div>
</template>

<script>
import MemberChoose from "@/components/dialog/member/MemberChoose"

import GoodsTabsChoose from "@/components/dialog/product/GoodsTabsChoose";
import adminOrderTable from "@/components/dialog/order/adminOrderTable" // 管理员订单
import AddUserMobile from "@/components/dialog/order/AddUserMobile"

import { memberOrderBuild, buildmulti } from "@/api/member"
import { expressList } from "@/api/common"

export default {
  components: {
    MemberChoose,
    adminOrderTable,
    GoodsTabsChoose,
    AddUserMobile
  },
  data() {
    return {
      goodsChooseDialog: false,
      userChooseDialog: false,
      loading: false,
      dataForm: {
        ref_type: null,
        ref_id: "",
        price: "",
        pay_type: 3
      },
      goods: {},
      users: [],
      rules: {
        ref_type: [{ required: true, message: "请选择商品类型", trigger: "blur" }],
        price: [{ required: true, message: "请填写商品价格", trigger: "blur" }],
        users: [
          {
            required: true, message: '请选择用户', trigger: 'change', validator: (rule, value, callback) => {
              if (!this.users.length && !this.userMobiles.length) {
                return callback(new Error(rule.message))
              } else {
                callback()
              }
            }
          }
        ],
        ref_id: [{
          required: true, message: "请选择商品", trigger: "change", validator: (rule, value, callback) => {
            if (!this.products.length) {
              return callback(new Error(rule.message))
            } else {
              callback()
            }
          }
        }],
      },
      express: false,
      expressList: [],
      goodsType: [
        { label: '课程', value: 1 },
        { label: '资料', value: 4 },
        { label: '专栏', value: 3 },
        { label: '题库', value: 2 },
      ],
      adminOrderTableDialog: false,
      adminOrderTableContent: {},
      products: [],
      adduserDialog: false,
      userMobiles: [],
    };
  },
  created() {
    this.$store.dispatch('getAdminList')
  },
  methods: {
    fetchExpressList() {
      expressList().then((res) => {
        if (res) {
          this.expressList = res.list;
        }
      });
    },
    handleTypeChange(type) {
      this.goods = {}
    },
    handleUserChoose() {
      this.userChooseDialog = true;
    },
    handleGoodChoose() {
      this.goodsChooseDialog = true;
    },
    handleExpressChange(v) {
      if (!v) {
        this.dataForm.express_id = ''
      }
    },
    handleUserRemove(item) {
      this.users = this.users.filter(v => v.id !== item.id)
    },
    handleProductsRemove(item) {
      this.products = this.products.filter(v => v.id !== item.id)
    },
    saveMember({ users }) {
      this.users = users
    },
    saveGoods(val) {
      this.products = val.goods
    },
    handleSubmit() {
      let time = this.SecondToDate(Number((this.users.length * 5)) + Number((this.userMobiles.length * 5)))
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let loadingInstance = this.$loading({
            text: "订单任务创建中...请不要关闭页面!",
            background: "rgba(0, 0, 0, 0.8)",
          });

          this.loading = true
          let user_val = this.users.map(v => ({ id: v.id }))
          let query = {
            arr_ref_data: this.products.map(v => {
              return {
                ref_type: v.type,
                ref_id: v.id,
                price: v.price
              }
            }),
            pay_type: 3,
            users: user_val,
            user_mobiles: this.userMobiles.length ? this.userMobiles.map(v => {
              return v.mobile
            }) : []
          }
          buildmulti(query).then(res => {
            if (res == null) {
              this.$message.success('请求成功')
              loadingInstance.close();
              this.$confirm(`已成功提交订单创建任务，后台正在陆续创建中，预计需要${time}完成！`, '提示', {
                confirmButtonText: '好的',
                cancelButtonText: '查看任务列表',
                type: 'warning'
              }).then(() => {
                this.handleClose()
              }).catch(() => {
                this.openAdminOrderTableDialog()
              });
            }
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleClose() {
      this.$router.replace('/order/list')
    },
    openAdminOrderTableDialog() {
      this.adminOrderTableDialog = true
    },
    SecondToDate(msd) {
      var time = msd
      if (null != time && "" != time) {
        if (time > 60 && time < 60 * 60) {
          time = parseInt(time / 60.0) + "分钟" + parseInt((parseFloat(time / 60.0) -
            parseInt(time / 60.0)) * 60) + "秒";
        }
        else if (time >= 60 * 60 && time < 60 * 60 * 24) {
          time = parseInt(time / 3600.0) + "小时" + parseInt((parseFloat(time / 3600.0) -
            parseInt(time / 3600.0)) * 60) + "分钟" +
            parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) -
              parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + "秒";
        } else if (time >= 60 * 60 * 24) {
          time = parseInt(time / 3600.0 / 24) + "天" + parseInt((parseFloat(time / 3600.0 / 24) -
            parseInt(time / 3600.0 / 24)) * 24) + "小时" + parseInt((parseFloat(time / 3600.0) -
              parseInt(time / 3600.0)) * 60) + "分钟" +
            parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) -
              parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + "秒";
        }
        else {
          time = parseInt(time) + "秒";
        }
      }
      return time;
    },
    openAddUserDialog() {
      this.adduserDialog = true
    },
    adduserDialogSubmit(data) {
      this.userMobiles = data
    },
    handleRemoveUserMobile(item, index) {
      this.userMobiles.splice(index, 1)
    }
  },
};
</script>

<style scoped lang="less">
.course-create {
  .header {
    background: #fff;
    padding: 20px;

    .breadcrumb {
      margin-bottom: 20px;
    }
    .content {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      // flex-direction: column;
      // align-items: center;
    }
  }
  .main {
    background: #fff;
    padding: 20px;
    margin-top: 10px;

    .title {
      font-size: 32px;
      font-weight: bold;
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    margin-top: 20px;

    .dataForm {
      width: 700px;

      /deep/ .el-input {
        width: 500px;
      }
    }

    .button {
      font-size: 14px;
      padding: 12px 20px;
      margin-bottom: 10px;

      &.small {
        padding: 9px 15px;
      }
    }
  }
  .express-item {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    /deep/.el-select .el-input {
      width: 400px;
    }
  }
  .tag-wrap {
    display: flex;
    flex-wrap: wrap;
  }
  .user-item {
    margin-right: 5px;
    margin-bottom: 5px;
  }
}
</style>
